import React, { memo } from 'react';
import { Button } from '@dexma/ui-components';
import { StyledConfigFooter } from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/Configuration/style';
import i18n from 'asset/translation';
import gtmIds from 'adapter/in/dashboards/config/gtm';

export type SaveWidgetProps = {
    onSave: () => Promise<void>;
    isLoading: boolean;
    isDisabled: boolean;
};

const SaveWidget = memo(({ isDisabled, isLoading, onSave }: SaveWidgetProps) => (
    <StyledConfigFooter data-testid='save-widget'>
        <Button
            text={i18n.t('dashboards.edit.saveWidget')}
            dataId={gtmIds.addWidget.sidePanel.actions.save}
            isLoading={isLoading}
            isDisabled={isDisabled}
            onClick={onSave}
        />
    </StyledConfigFooter>
));

export default SaveWidget;
